import { useEffect, useRef, useState } from 'react';

// images
import MainViewImage1_hd from '../images/pages/mainpage/mainview1-hd.jpg';
import MainViewImage2_hd from '../images/pages/mainpage/mainview2-hd.jpg';
import MainViewImage3_hd from '../images/pages/mainpage/mainview3-hd.jpg';
import MainViewImage1_1920 from '../images/pages/mainpage/mainview1-1920.jpg';
import MainViewImage2_1920 from '../images/pages/mainpage/mainview2-1920.jpg';
import MainViewImage3_1920 from '../images/pages/mainpage/mainview3-1920.jpg';
import MainViewImage1_uhd from '../images/pages/mainpage/mainview1-uhd.jpg';
import MainViewImage2_uhd from '../images/pages/mainpage/mainview2-uhd.jpg';
import MainViewImage3_uhd from '../images/pages/mainpage/mainview3-uhd.jpg';
import MainViewImage1_4k from '../images/pages/mainpage/mainview1-4k.jpg';
import MainViewImage2_4k from '../images/pages/mainpage/mainview2-4k.jpg';
import MainViewImage3_4k from '../images/pages/mainpage/mainview3-4k.jpg';
import ArrowIcon from "../images/pages/mainpage/arrow.svg";


// 이미지 슬라이드 넘어가는 시간
const SLIDE_TIME = 2000;


function MainPage() {
    const curImageRef = useRef(1);
    const [imageLeft, setImageLeft] = useState(0);
    const [loading, setLoading] = useState(false);

    const [autoSlide, setAutoSlide] = useState(1);

    const dragRef = useRef();
    const [dragStart, setDragStart] = useState(0);
    const [dragDiff, setDragDiff] = useState(0);

    const downloadGLMP = () => {
        let isResp = window.confirm("Do you want to download the installation file?");
        if (isResp) {
            var url =
            "https://bgl-resources.s3.ap-northeast-2.amazonaws.com/installer/" +
            process.env.REACT_APP_LAUNCHER_INSTALL_FILE_NAME +
            ".exe";
            window.open(url, "_blank");
        }
    }

    const moveToSelectedImage = (targetNum) => {
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
        },SLIDE_TIME);
          
        setImageLeft(`-${(targetNum-1)*100}%`);
    
        curImageRef.current = targetNum;
    }

    const moveToNextImage = (targetNum) => {
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
        },SLIDE_TIME);

        if(curImageRef.current < targetNum){            
            setImageLeft(`-${(targetNum-1)*100}%`);
        }else{
            setImageLeft(`-${(2+targetNum)*100}%`);

            setTimeout(()=>{
                setImageLeft(`-${(targetNum-1)*100}%`);
            },SLIDE_TIME);            
        }

        curImageRef.current = targetNum;
    }

    const handleSlideDrag = (e) => {
        if(dragStart-e.clientX > 0 && e.clientX){
            setDragDiff(dragStart-e.clientX);
        }
    }

    const handleSlideDragStart = (e) => {
        setAutoSlide(false);
        setDragStart(e.clientX);
    }

    const handleSlideDragEnd = (e) => {
        const endDiff = dragStart - e.clientX;
        if(100 < endDiff){
            moveToNextImage(curImageRef.current===3 ? 1 : curImageRef.current+1);
        }
        setAutoSlide(true);
        setDragStart(0);
        setDragDiff(0);
    }

    useEffect(() => {
        setAutoSlide(true);
    }, []);

    useEffect(()=>{

        let interval;

        if(autoSlide){
            interval = setInterval(() => {
                if(curImageRef.current===3){
                    moveToNextImage(1);
                }else{
                    moveToNextImage(curImageRef.current+1);
                }
            }, 6000);
        }        

        return () => {
            clearInterval(interval);
        }
    },[autoSlide])

    return (
        <div className="MainPage">
            <div
                ref={dragRef}
                className='DragElem'
                draggable={`${loading ? "false" : "true"}`}
                onDrag={handleSlideDrag}
                onDragStart={handleSlideDragStart}
                onDragEnd={handleSlideDragEnd}

            />
            <div className='MainView'>
                <div
                    className={`ImageWrapper ${loading ? "ImageTransition" : ""}`}
                    style={{left: `calc(${imageLeft} - ${dragDiff}px)`}}
                    draggable="false"
                >
                    {/* image hd */}
                    <img className='MainViewImage Image_HD' src={MainViewImage1_hd} alt="main page view" />
                    <img className='MainViewImage Image_HD' src={MainViewImage2_hd} alt="main page view" />
                    <img className='MainViewImage Image_HD' src={MainViewImage3_hd} alt="main page view" />
                    <img className='MainViewImage Image_HD' src={MainViewImage1_hd} alt="main page view" />
                    <img className='MainViewImage Image_HD' src={MainViewImage2_hd} alt="main page view" />
                    {/* image 1920 */}
                    <img className='MainViewImage Image_1920' src={MainViewImage1_1920} alt="main page view" />
                    <img className='MainViewImage Image_1920' src={MainViewImage2_1920} alt="main page view" />
                    <img className='MainViewImage Image_1920' src={MainViewImage3_1920} alt="main page view" />
                    <img className='MainViewImage Image_1920' src={MainViewImage1_1920} alt="main page view" />
                    <img className='MainViewImage Image_1920' src={MainViewImage2_1920} alt="main page view" />
                    {/* image uhd */}
                    <img className='MainViewImage Image_UHD' src={MainViewImage1_uhd} alt="main page view" />
                    <img className='MainViewImage Image_UHD' src={MainViewImage2_uhd} alt="main page view" />
                    <img className='MainViewImage Image_UHD' src={MainViewImage3_uhd} alt="main page view" />
                    <img className='MainViewImage Image_UHD' src={MainViewImage1_uhd} alt="main page view" />
                    <img className='MainViewImage Image_UHD' src={MainViewImage2_uhd} alt="main page view" />
                    {/* image 4k */}
                    <img className='MainViewImage Image_4K' src={MainViewImage1_4k} alt="main page view" />
                    <img className='MainViewImage Image_4K' src={MainViewImage2_4k} alt="main page view" />
                    <img className='MainViewImage Image_4K' src={MainViewImage3_4k} alt="main page view" />
                    <img className='MainViewImage Image_4K' src={MainViewImage1_4k} alt="main page view" />
                    <img className='MainViewImage Image_4K' src={MainViewImage2_4k} alt="main page view" />
                </div>              
            </div>            
            <div className="MainTitle" onDragStart={handleSlideDrag}>
                <div>A new office experience</div>
                <div>without a daily commute</div>
            </div>
            <button type="button" className='MainButton' onClick={downloadGLMP}>
                Free Download
            </button>
            <img className='MainButtonIcon' src={ArrowIcon} alt="main page button arrow icon" />
            <div className="MainDescription">
                <div>Experience new spatial connections in GLMP. Join, communicate, and collaborate with people,</div>
                <div>transcending the limitations of the real world and leveraging the efficiency of the extended space.</div>
            </div>
            <div className="MainViewButton" onMouseEnter={()=>setAutoSlide(false)} onMouseLeave={()=>setAutoSlide(true)}>
                <button
                    type="button"
                    className={`${curImageRef.current===1 ? 'ButtonSelected' : ""}`}
                    disabled={curImageRef.current===1 || loading}
                    onClick={()=>moveToSelectedImage(1)} />
                <button
                    type="button"
                    className={`${curImageRef.current===2 ? 'ButtonSelected' : ""}`}
                    disabled={curImageRef.current===2 || loading}
                    onClick={()=>moveToSelectedImage(2)}
                />
                <button
                    type="button"
                    className={`${curImageRef.current===3 ? 'ButtonSelected' : ""}`}
                    disabled={curImageRef.current===3 || loading}
                    onClick={()=>moveToSelectedImage(3)}
                />
            </div>
        </div>
    );
}

export default MainPage;